export enum ToasterType {
  success = 'success',
  danger = 'danger',
  info = 'info'
}
